var usernames = ["KingHassan",
"AbigailWilliams",
"Alexander",
"AmakusaShirou",
"Anastasia",
"AngraMainyu",
"AnneBonnyAndMaryRead",
"AntonioSalieri",
"Arash",
"Arjuna",
"ArthurPendragon",
"ArtoriaPendragon",
"AsagamiFujino",
"Asterios",
"Astolfo",
"Atalanta",
"AtalantaAlter",
"Attila",
"AttilaTheSanta",
"Avicebron",
"Bb",
"Bedivere",
"Beowulf",
"BillyTheKid",
"Boudica",
"Brynhildr",
"Caligula",
"Carmilla",
"Chacha",
"Sanson",
"CharlesBabbage",
"Chevalier",
"ChloeVonEinzbern",
"ChristopherColumbus",
"Circe",
"Cleopatra",
"CursedArmHassan",
"CuChulainn",
"CuChulainnAlter",
"CuChulainnCaster",
"CuChulainnPrototype",
"DariusIii",
"David",
"Diarmuid",
"EdmondDantes",
"EdwardTeach",
"ElizabethBathory",
"Emiya",
"EmiyaAlter",
"EmiyaAssassin",
"Enkidu",
"Ereshkigal",
"EricBloodaxe",
"Euryale",
"Fergus",
"Fionn",
"FrancisDrake",
"Frankenstein",
"FrankensteinSaber",
"FuumaKotarou",
"JuliusCaesar",
"Gawain",
"Georgios",
"Geronimo",
"Gilgamesh",
"GilgameshCaster",
"GillesDeRais",
"Gorgon",
"HansChristianAndersen",
"HassanOfSerenity",
"Hector",
"HelenaBlavatsky",
"JekyllAndHyde",
"Heracles",
"HessianLobo",
"HijikataToshizou",
"HouzouinInshun",
"HundredfacedHassan",
"IbarakiDouji",
"IllyasvielVonEinzbern",
"IrisvielDressOfHeaven",
"Ishtar",
"IshtarRider",
"Iskandar",
"IvanTheTerrible",
"JackTheRipper",
"JaguarMan",
"JamesMoriarty",
"Jeanne",
"JeanneAlter",
"JeanneAlterSantaLily",
"JingKe",
"Karna",
"KatouDanzou",
"KatsushikaHokusai",
"KidGil",
"Kiyohime",
"KiyohimeLancer",
"Lancelot",
"LancelotSaber",
"DaVinci",
"Leonidas",
"LiShuwen",
"LuBu",
"MarieAntoinette",
"MarieAntoinetteCaster",
"MashuKyrielight",
"MataHari",
"MechaElichan",
"MechaElichanMkii",
"Medb",
"Medea",
"MedeaLily",
"Medusa",
"MedusaLancer",
"Meltlilith",
"Mephistopheles",
"Merlin",
"MinamotoNoYorimitsu",
"MinamotoNoYorimitsuLancer",
"MiyamotoMusashi",
"MochizukiChiyome",
"Mordred",
"MordredRider",
"MusashibouBenkei",
"MysteriousHeroineX",
"MysteriousHeroineXAlter",
"NeroClaudius",
"NeroClaudiusBride",
"NeroClaudiusCaster",
"Nezha",
"Nightingale",
"NikolaTesla",
"Nitocris",
"NitocrisAssassin",
"NurseryRhyme",
"OdaNobunaga",
"OdaNobunagaBerserker",
"OkitaSouji",
"Orion",
"Osakabehime",
"Ozymandias",
"Paracelsus",
"Parvati",
"Passionlip",
"PaulBunyan",
"Penthesilea",
"QueenOfSheba",
"Quetzalcoatl",
"Rama",
"RobinHood",
"Romulus",
"RyougiShiki",
"RyougiShikiSaber",
"SaintMartha",
"SaintMarthaRuler",
"SakataKintoki",
"SakataKintokiRider",
"SasakiKojirou",
"ScathachAssassin",
"Scathach",
"Scheherazade",
"Semiramis",
"SessyoinKiara",
"SherlockHolmes",
"ShutenDouji",
"Siegfried",
"Spartacus",
"Stheno",
"SuzukaGozen",
"TamamoCat",
"TamamoNoMae",
"TamamoNoMaeLancer",
"TawaraTouta",
"PhantomOfTheOpera",
"ThomasEdison",
"TomoeGozen",
"Tristan",
"Ushiwakamaru",
"Vlad",
"VladExtra",
"WilliamShakespeare",
"Mozart",
"WuZetian",
"Xuanzang",
"YagyuuMunenori",
"YanQing",
"Waver"];

export default usernames;


// WEBPACK FOOTER //
// ./src/components/constants/usernames.js